import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getPlanDetails = payload => api.get(`/platform/plan/${payload.planId}`, payload)

const getPlanLevel = payload => api.get(`/platform/plan/select/level`, payload)

const getPlanData = payload => api.get(`/platform/admin/plan/manage`, payload)

const createPlan = payload => api.post('/platform/plan', payload.data, { params: payload.params })

const editPlan = payload =>
  api.put(`/platform/admin/plan/edit`, payload.data, { params: payload.params })

const deletePlan = payload =>
  api.delete(`/platform/admin/plan/manage/${payload.companyId}`, { params: payload.params })

export default {
  getPlanDetails,
  getPlanLevel,
  getPlanData,
  createPlan,
  editPlan,
  deletePlan
}
